export default __webpack_public_path__ + "static/media/squash2.f1a045f1.png";